// MissionWeekSelector.jsx
import React from "react";
import { ChevronLeft, ChevronRight } from "../../assets/icons";
import MissionTimeSheet from "./MissionTimeSheet";

const MissionWeekSelector = ({
  isWaitingMission,
  missionByWeek,
  currentWeekIndex,
  currentWeekMissions,
  canGoPrev,
  canGoNext,
  goPrevWeek,
  goNextWeek,
  getWeekLabel,
  timeCut,
  /** Offset sous le bandeau intérimaire sticky (px) */
  weekStickyTopPx = 0,
}) => {
  if (isWaitingMission) {
    return (
      <div className="flex w-full min-w-0 flex-col gap-6">
        {[1, 2, 3, 4, 5].map((i) => (
          <MissionTimeSheet key={i} isWaiting={true} />
        ))}
      </div>
    );
  }

  if (!missionByWeek?.length) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 px-2 py-8 text-center">
        <h1 className="text-xl font-bold sm:text-2xl">Mission introuvable</h1>
        <p className="max-w-md text-sm text-gray-600 sm:text-base">
          La mission que vous cherchez est introuvable.
        </p>
      </div>
    );
  }

  const topPx = Math.max(weekStickyTopPx, 0);
  /** Petit espace sous le header sticky (bordure basse) quand la barre semaine est collée */
  const STICKY_GAP_BELOW_HEADER_PX = 10;

  return (
    <div className="flex w-full min-w-0 flex-col gap-6">
      <div
        className="sticky z-20 w-full bg-white pb-4"
        style={{ top: `${topPx + STICKY_GAP_BELOW_HEADER_PX}px` }}
      >
        <div className="flex w-full max-w-full flex-wrap items-center justify-center gap-x-1 gap-y-2 rounded border px-3 py-2 sm:w-fit sm:justify-start sm:px-4">
          <button
            type="button"
            className={`shrink-0 cursor-pointer ${canGoPrev ? "" : "opacity-50"}`}
            aria-label="Chevron left"
            onClick={goPrevWeek}
            disabled={!canGoPrev}
            name="header_mission_week_selector_prev_date"
          >
            <ChevronLeft wh={20} color={canGoPrev ? "#374151" : "#9CA3AF"} />
          </button>
          <div className="min-w-0 max-w-full text-center text-[14px] leading-snug sm:whitespace-nowrap sm:text-left">
            {getWeekLabel()}
          </div>
          <button
            type="button"
            className={`shrink-0 cursor-pointer ${canGoNext ? "" : "opacity-50"}`}
            aria-label="Chevron right"
            onClick={goNextWeek}
            disabled={!canGoNext}
            name="header_mission_week_selector_next_date"
          >
            <ChevronRight wh={20} color={canGoNext ? "#374151" : "#9CA3AF"} />
          </button>
        </div>
      </div>

      {currentWeekMissions.map((item, index) => {
        return (
          <MissionTimeSheet
            key={index}
            mission={item}
            timeCut={timeCut}
          />
        );
      })}
    </div>
  );
};

export default MissionWeekSelector;
